import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      console.log(savedPosition, 'savedPosition')
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },

  routes: [
    {
      path: '/Index99',
      name: 'Index',
      component: () => import("../views/index99.vue")
    },
    {
      path: '/',
      name: 'newIndex',
      component: () => import("../views/newIndex.vue"),
      meta: {
        title: '',
      }

    },
    {
      path: "/zActivity",
      name: "zActivity",
      component: () => import("../views/zActivity.vue"),
      meta: {
        title: '',
      }
    },
    {
      path: "/push",
      name: "Push",
      component: () => import("../views/push.vue")
    },
    {
      path: "/procedures",
      name: "Procedures",
      component: () => import("../views/procedures.vue"),
      meta: {
        title: '',
      }
    },
    {
      path: "/mine",
      name: "Mine",
      component: () => import("../views/mine.vue"),
      meta: {
        title: '',
      }
    },
    {
      // path: "/zhaoMore",
      // name: "zhaoMore",
      // component: () => import("../views/zhaoMore.vue"),
      path: "/recruitmentinfoList",
      name: "recruitmentinfoList",
      component: () => import("../views/recruitmentinfoList.vue"),
      meta: {
        title: '',
      }
    },
    {
      // path: "/xuanMore",
      // name: "xuanMore",
      // component: () => import("../views/xuanMore.vue")
      path: "/recruitmentFairList",
      name: "recruitmentFairList",
      component: () => import("../views/recruitmentFairList.vue")
    },
    {
      // path: "/shuangMore",
      // name: "shuangMore",
      // component: () => import("../views/shuangMore.vue")
      path: "/bilateralchosefairList",
      name: "bilateralchosefairList",
      component: () => import("../views/bilateralchosefairList.vue")
    },
    {
      path: "/zhaoMoreCity",
      name: "zhaoMoreCity",
      component: () => import("../views/zhaoMoreCity.vue")
    },
    {
      path: "/zhaoMoreSelect",
      name: "zhaoMoreSelect",
      component: () => import("../views/zhaoMoreSelect.vue")
    },
    {
      // path: "/xuanDetail",
      // name: "xuanDetail",
      // component: () => import("../views/xuanDetail.vue")
      path: "/recruitmentFairForm",
      name: "recruitmentFairForm",
      component: () => import("../views/recruitmentFairForm.vue")
    },
    {
      // path: "/zhaoDetail",
      // name: "zhaoDetail",
      // component: () => import("../views/zhaoDetail.vue")
      path: "/recruitmentinfoForm",
      name: "recruitmentinfoForm",
      component: () => import("../views/recruitmentinfoForm.vue")
    },
    {
      // path: "/shuangDetail",
      // name: "shuangDetail",
      // component: () => import("../views/shuangDetail.vue")
      path: "/bilateralchosefairForm",
      name: "bilateralchosefairForm",
      component: () => import("../views/bilateralchosefairForm.vue")
    },
    {
      // path: "/zhaoCompany",
      // name: "zhaoCompany",
      // component: () => import("../views/zhaoCompany.vue")
      path: "/corporationinfoForm",
      name: "corporationinfoForm",
      component: () => import("../views/corporationinfoForm.vue")
    },
    {
      path: "/Calendar",
      name: "Calendar",
      component: () => import("../components/calendar.vue")
    },
    {
      // path: "/shuangDetailYue",
      // name: "shuangDetailYue",
      // component: () => import("../views/shuangDetailYue.vue")
      path: "/bilateralchosefairOrderForm",
      name: "bilateralchosefairOrderForm",
      component: () => import("../views/bilateralchosefairOrderForm.vue")
    },
    {
      path: "/xuanVideo",
      name: "xuanVideo",
      component: () => import("../views/xuanVideo.vue")
    },
    {
      // path: "/activityMore",
      // name: "activityMore",
      // component: () => import("../views/activityMore.vue")
      path: "/trainActivities",
      name: "trainActivities",
      component: () => import("../views/trainActivities.vue")
    },
    {
      // path: "/activityDetail",
      // name: "activityDetail",
      // component: () => import("../views/activityDetail.vue")
      path: "/trainDetail",
      name: "trainDetail",
      component: () => import("../views/trainDetail.vue")
    },
    {
      // path: "/newsMore",
      // name: "newsMore",
      // component: () => import("../views/newsMore.vue"),
      path: "/newsList",
      name: "newsList",
      component: () => import("../views/newsList.vue"),
      meta: {
        title: '',
      }
    },
    {
      path: "/newsDetail",
      name: "newsDetail",
      component: () => import("../views/newsDetail.vue")
    },
    {
      path: "/videoDetail",
      name: "videoDetail",
      component: () => import("../views/videoDetail.vue")
    }
  ],
})

router.beforeEach((to, from, next) => {
  // console.log(to, 'to');
  // console.log(from, 'from');

  if (to.meta.title) {
    document.title = to.meta.title
  }

  next();

  // let isLogin = window.sessionStorage.getItem('userInfo');
  // if (isLogin) {
  //   next()
  // } else {
  //   if (to.path === '/login') {
  //     next()
  //   } else {
  //     next('/login')
  //   }
  // }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js